import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { gettingAllPaycodes, justifyException } from "utils/Timecard";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { LoadingButton } from "@mui/lab";
import moment from "moment";
import { jwtDecode } from "jwt-decode";
import { Context } from "components/table/timecard/Context";

const AddPaycode = ({ open, setOpen, employee, cell }) => {
	const { t } = useTranslation();

	const { reloading } = useContext(Context);

	const [loadingPaycodes, setLoadingPaycodes] = useState(true);
	const [paycodes, setPaycodes] = useState([]);
	const [selectedPaycode, setSelectedPaycode] = useState("");
	const [start, setStart] = useState(null);
	const [amount, setAmount] = useState(null);
	const [selectedDay, setSelectedDay] = useState(moment(new Date()));
	const [comment, setComment] = useState("");
	const [note, setNote] = useState("");

	const [loadingAssigningPaycode, setLoadingAssigningPaycode] =
		useState(false);

	const closing = () => {
		setOpen(false);
		setLoadingPaycodes(true);
		setPaycodes([]);
		setSelectedPaycode("");
		setStart(null);
		setAmount(null);
		setSelectedDay(moment(new Date()));
		setComment("");
		setNote("");
		setLoadingAssigningPaycode(false);
	};

	useEffect(() => {
		if (open) {
			// Perform any necessary actions when the dialog opens}
			setSelectedDay(moment(cell?.row, "YYYY-MM-DD"));
			gettingAllPaycodes(setLoadingPaycodes, setPaycodes);
		}
	}, [cell, open]);

	return (
		<>
			<Dialog
				fullWidth
				open={open}
				onClose={() => {
					closing();
				}}
			>
				<DialogTitle
					sx={{
						background: (theme) => theme.palette.background.default,
					}}
				>
					<Typography variant="body3">
						{t("timekeeper.timecard.table.dialog.assing.title")}
					</Typography>
				</DialogTitle>

				<DialogContent
					dividers
					sx={{
						background: (theme) => theme.palette.background.default,
					}}
				>
					<Grid container spacing={2}>
						<Grid size={6}>
							<TextField
								id="employee-fullname"
								label={t(
									"timekeeper.timecard.table.dialog.assing.employee"
								)}
								variant="outlined"
								value={employee?.full_name}
								disabled
								fullWidth
								required
							/>
						</Grid>

						<Grid size={6}>
							<FormControl required fullWidth>
								<InputLabel id="l-paycodes">
									{t(
										"timekeeper.timecard.table.dialog.assing.paycodes"
									)}
								</InputLabel>

								<Select
									disabled={loadingPaycodes}
									labelId="l-paycodes"
									id="paycodes"
									value={selectedPaycode}
									label={t(
										"timekeeper.timecard.table.dialog.assing.paycodes"
									)}
									onChange={(e) => {
										setSelectedPaycode(e.target.value);
									}}
								>
									{paycodes.map((paycode) => (
										<MenuItem
											key={paycode.paycode_id}
											value={paycode.paycode_id}
										>
											{paycode.name}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>

						<Grid size={4}>
							<DatePicker
								value={selectedDay}
								onChange={(nv) => setSelectedDay(nv)}
								sx={{
									border: "1px solid rgba(0,0,0,0.23)",
									borderRadius: 1,
								}}
							/>
						</Grid>

						<Grid size={4}>
							<TimePicker
								label={t(
									"timekeeper.timecard.table.dialog.assing.start"
								)}
								value={start}
								onChange={(nv) => setStart(nv)}
								ampm={false}
								sx={{ width: "100%" }}
							/>
						</Grid>

						<Grid size={4}>
							<TextField
								id="amount"
								label={t(
									"timekeeper.timecard.table.dialog.assing.amount"
								)}
								variant="outlined"
								value={amount}
								onChange={(e) => setAmount(e.target.value)}
								type="number"
								fullWidth
								required
							/>
						</Grid>

						<Grid size={12}>
							<TextField
								id="comment"
								label={t(
									"timekeeper.timecard.table.dialog.assing.comment"
								)}
								variant="outlined"
								value={comment}
								onChange={(e) => setComment(e.target.value)}
								fullWidth
								multiline
								rows={2}
							/>
						</Grid>

						<Grid size={12}>
							<TextField
								id="note"
								label={t(
									"timekeeper.timecard.table.dialog.assing.note"
								)}
								variant="outlined"
								value={note}
								onChange={(e) => setNote(e.target.value)}
								fullWidth
								multiline
								rows={2}
							/>
						</Grid>
					</Grid>
				</DialogContent>

				<DialogActions
					sx={{
						background: (theme) => theme.palette.background.default,
					}}
				>
					<LoadingButton
						variant="contained"
						disableElevation
						onClick={() => {
							const body = {
								id_employee: employee?.id,
								id_paycode: selectedPaycode,
								date: selectedDay.format("YYYY-MM-DD"),
								amount: parseFloat(amount),
								start: start.format("HH:mm"),
								comment: comment,
								note: note,
								create_by: jwtDecode(
									localStorage.getItem("access_token")
								).user_id,
								template: "Timecard",
								lastupdate_by: jwtDecode(
									localStorage.getItem("access_token")
								).user_id,
							};

							justifyException(
								setLoadingAssigningPaycode,
								body,
								closing,
								reloading
							);
						}}
						loading={loadingAssigningPaycode}
						disabled={
							employee?.id === undefined ||
							selectedPaycode === "" ||
							selectedDay === null ||
							start === null ||
							amount === null
						}
					>
						{t("timekeeper.schedule.table.modals.add.buttons.save")}
					</LoadingButton>

					<Button
						sx={{ mr: 2.25 }}
						variant="contained"
						disableElevation
						color="error"
						onClick={() => {
							closing();
						}}
					>
						{t(
							"timekeeper.schedule.table.modals.add.buttons.cancel"
						)}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export { AddPaycode };
